import Modal from "@resources/js/ui/Modal";

const languageModalElement = document.querySelector('.js-lang-modal')

if (languageModalElement){
    new Modal(languageModalElement, {
        trigger: '.js-lang-modal-open',
        selectors: {close: '.js-lang-modal-close', content:'.js-lang-modal-content'}
    })
}
